export const makePath = (...segments) => {
  // Filter out null, undefined, and empty string values to prevent paths like 'employers//calculations'
  const filtered = (Array.isArray(segments) ? segments : [segments])
    .filter(segment => segment !== null && segment !== undefined && segment !== '');
  
  return filtered.join('/');
}